import { LocalLoginOption } from '@web/types/globals';

export default (): LocalLoginOption[] =>
  window.Clearstream.global.localLoginOptions ?? [];
